<template>
  <div class="ct-centre">
    <ul class="breadnav">
      <li @click="linkytowin">
        <img src="../../static/images/icon_logo.png" alt="" />
      </li>
      <li>&gt;</li>
      <li @click="linkindex">专题首页</li>
    </ul>
    <div class="screen">
      <!--<h2 @click="linkindex">专题首页</h2>-->
      <div class="form">
        <span>形式:</span>
        <ul>
          <li
            v-for="(todo, index) in form"
            v-on:click="formclickact(index, todo.value)"
            v-bind:class="{ active: index == formcurrent }"
            :key="index"
          >
            {{ todo.text }}
          </li>
        </ul>
      </div>
      <div class="classify">
        <span>分类:</span>
        <ul>
          <li
            v-for="(todo, index) in classify"
            v-on:click="classifyclickact(index, todo.text)"
            v-bind:class="{ active: index == classifycurrent }"
            :key="index"
          >
            {{ todo.text }}
          </li>
        </ul>
      </div>
      <div class="grade">
        <span>年级:</span>
        <ul>
          <li
            v-for="(todo, index) in grade"
            v-on:click="gradeclickact(index, todo.text)"
            v-bind:class="{ active: index == gradecurrent }"
            :key="index"
          >
            {{ todo.text }}
          </li>
        </ul>
      </div>
      <div class="subject">
        <span>科目:</span>
        <ul>
          <li
            v-for="(todo, index) in subject"
            v-on:click="subjectclickact(index, todo.text)"
            v-bind:class="{ active: index == subjectcurrent }"
            :key="index"
          >
            {{ todo.text }}
          </li>
        </ul>
      </div>
      <div class="dates">
        <span>时间:</span>
        <ul>
          <li
            v-for="(todo, index) in dates"
            v-on:click="datesclickact(index, todo.text)"
            v-bind:class="{ active: index == datescurrent }"
            :key="index"
          >
            {{ todo.text }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import teacherData from "../../static/json/data.js";
export default {
  mounted() {
    /*  console.log(this.condition)*/
    if (
      JSON.parse(localStorage.getItem("condition")) != "" &&
      this.$route.path != "/" &&
      this.$route.path != "/videodetails" &&
      this.$route.path != "/details"
    ) {
      this.sousuoData = JSON.parse(localStorage.getItem("condition"));
      this.classifycurrent = this.sousuoData.classifycurrent;
      this.gradecurrent = this.sousuoData.gradecurrent;
      this.subjectcurrent = this.sousuoData.subjectcurrent;
      this.link = this.$route.path;
      this.datescurrent = this.sousuoData.datescurrent;
      if (this.link == "/videolist") {
        this.formcurrent = 0;
      } else {
        this.formcurrent = 1;
      }
      this.condition = this.sousuoData.data;
      if (this.formcurrent == 0) {
        this.conditionsData = teacherData._vconditionsData();
      } else if (this.formcurrent == 1) {
        this.conditionsData = teacherData._tconditionsData();
      }
      this.sx();
    }
  },
  data() {
    return {
      // 筛选联动数据
      gradeNum: 20,
      classNum: 20,
      // 搜索框数据保存
      sousuoData: {},
      //初次检索数据
      data: [],
      // 要发送的数据
      main_data: [],
      //条件
      condition: {
        classify: "高中",
        grade: "全部",
        subject: "全部",
        dates: "全部"
      },
      link: "/videolist",
      videosData: teacherData._videosData(),
      conditionsData: [],
      teachersData: teacherData._teachersData(),

      classifycurrent: 0,
      gradecurrent: 0,
      subjectcurrent: 0,
      formcurrent: 0,
      datescurrent: 0,

      classify: [{ text: "高中" }],
      grade: [
        { text: "全部" },
        { text: "高一" },
        { text: "高二" },
        { text: "高三" }
      ],
      subject: [
        { text: "全部" },
        { text: "语文" },
        { text: "数学" },
        { text: "英语" },
        { text: "物理" },
        { text: "化学" },
        { text: "生物" },
        { text: "政治" },
        { text: "历史" },
        { text: "地理" }
      ],
      form: [
        { text: "试听课程", value: "/videolist" },
        { text: "老师简介", value: "/introducelist" }
      ],
      dates: [{ text: "全部" }, { text: "春季课" }, { text: "秋季课" }]
    };
  },
  methods: {
    sxone() {
      /*  if(this.condition.grade == "全部" && this.condition.subject =="全部"  && this.condition.dates == "全部"){
        this.conditionsData.forEach(val => {
          if (val.grade == this.condition.classify) {
            this.data.push(val);
          }
        });
      }else{*/
      if (this.condition.grade != "全部") {
        if (
          this.condition.dates != "全部" &&
          this.condition.subject == "全部"
        ) {
          this.conditionsData.forEach(val => {
            if (
              val.grade == this.condition.grade &&
              val.dates == this.condition.dates
            ) {
              this.data.push(val);
            }
          });
        } else if (
          this.condition.dates == "全部" &&
          this.condition.subject == "全部"
        ) {
          this.conditionsData.forEach(val => {
            if (val.grade == this.condition.grade) {
              this.data.push(val);
            }
          });
        } else if (
          this.condition.dates != "全部" &&
          this.condition.subject != "全部"
        ) {
          this.conditionsData.forEach(val => {
            if (
              val.grade == this.condition.grade &&
              val.subject == this.condition.subject &&
              val.dates == this.condition.dates
            ) {
              this.data.push(val);
            }
          });
        } else if (
          this.condition.dates == "全部" &&
          this.condition.subject != "全部"
        ) {
          this.conditionsData.forEach(val => {
            if (
              val.grade == this.condition.grade &&
              val.subject == this.condition.subject
            ) {
              this.data.push(val);
            }
          });
        }
      } else if (this.condition.subject != "全部") {
        if (this.condition.dates != "全部" && this.condition.grade == "全部") {
          this.conditionsData.forEach(val => {
            if (
              val.subject == this.condition.subject &&
              val.grade == this.condition.classify &&
              val.dates == this.condition.dates
            ) {
              this.data.push(val);
            }
          });
        } else {
          this.conditionsData.forEach(val => {
            if (
              val.subject == this.condition.subject &&
              val.grade == this.condition.classify
            ) {
              this.data.push(val);
            }
          });
        }
      } else if (this.condition.dates != "全部") {
        this.conditionsData.forEach(val => {
          if (
            val.dates == this.condition.dates &&
            val.grade == this.condition.classify
          ) {
            this.data.push(val);
          }
        });
      } else {
        this.conditionsData.forEach(val => {
          if (val.grade == this.condition.classify) {
            this.data.push(val);
          }
        });
      }
    },
    sx() {
      this.data = [];
      this.main_data = [];
      if (this.condition.classify == "初中") {
        this.grade = [
          { text: "全部" },
          { text: "初一" },
          { text: "初二" },
          { text: "初三" }
        ];
        this.subject = [
          { text: "全部" },
          { text: "语文" },
          { text: "数学" },
          { text: "英语" },
          { text: "物理" },
          { text: "化学" },
          { text: "生物" },
          { text: "政治" },
          { text: "历史" },
          { text: "地理" }
        ];

        this.sxone();
      } else if (this.condition.classify == "高中") {
        this.grade = [
          { text: "全部" },
          { text: "高一" },
          { text: "高二" },
          { text: "高三" }
        ];
        this.subject = [
          { text: "全部" },
          { text: "语文" },
          { text: "数学" },
          { text: "英语" },
          { text: "物理" },
          { text: "化学" },
          { text: "生物" },
          { text: "政治" },
          { text: "历史" },
          { text: "地理" }
        ];
        this.sxone();
      } else if (this.condition.classify == "小学") {
        this.grade = [
          { text: "全部" },
          { text: "一年级" },
          { text: "二年级" },
          { text: "三年级" },
          { text: "四年级" },
          { text: "五年级" },
          { text: "六年级" }
        ];
        this.subject = [
          { text: "全部" },
          { text: "语文" },
          { text: "数学" },
          { text: "英语" },
          { text: "科学" },
          { text: "编程" }
        ];
        this.sxone();
      } else {
        if (this.link == "/introducelist") {
          this.conditionsData.forEach(val => {
            if (val.grade == this.condition.classify) {
              this.data.push(val);
            }
          });
        } else {
          this.conditionsData.forEach(val => {
            if (val.grade == this.condition.classify) {
              this.data.push(val);
            }
          });
        }
      }

      localStorage.setItem(
        "condition",
        JSON.stringify({
          classifycurrent: this.classifycurrent,
          gradecurrent: this.gradecurrent,
          subjectcurrent: this.subjectcurrent,
          datescurrent: this.datescurrent,
          formcurrent: this.formcurrent,
          link: this.link,
          data: this.condition
        })
      );
      /*console.log(this.link);*/

      if (this.link == "/videolist") {
        // console.log("sp");
        for (var i = 0; i < this.data.length; i++) {
          for (var j = 0; j < this.videosData.length; j++) {
            if (this.videosData[j].code == this.data[i].video) {
              this.main_data.push(this.videosData[j]);
            }
          }
        }
      } else {
        // console.log("tc");
        for (var i = 0; i < this.data.length; i++) {
          for (var j = 0; j < this.teachersData.length; j++) {
            if (this.teachersData[j].code == this.data[i].teacher) {
              this.main_data.push(this.teachersData[j]);
            }
          }
        }
      }

      // if ((this.condition.grade == "全部" && this.link == "/introducelist")) {
      //   for (var i = 0; i < this.main_data.length; i++) {
      //     var test = 0;
      //     for (var j = 0; j < this.main_data.length; j++) {
      //       if (this.main_data[i].num == this.main_data[j].num) {
      //         test++;
      //         if (test == 2) {
      //            console.log(this.main_data.splice(j, 1));
      //         }
      //       }
      //     }
      //   }
      // }
      // console.log(this.main_data);

      this.$emit("getdata", this.main_data);
      /*  localStorage.setItem("getdata",this.main_data)*/
    },

    classifyclickact(index, text) {
      this.classifycurrent = index;
      this.condition.classify = text;
      /*    this.condition.grade=text;*/
      /*this.gradecurrent = 0;*/
      this.condition.grade = "全部";
      this.condition.subject = "全部";
      this.condition.dates = "全部";
      this.gradecurrent = 0;
      this.subjectcurrent = 0;
      this.datescurrent = 0;
      this.gradecurrent_ban = this.gradeNum;
      /*console.log(this.condition.classify);*/
      this.classNum = index;
      this.sx();
      if (this.$route.path != this.link) {
        this.$router.push({
          path: this.link
        });
      }
    },
    gradeclickact: function(index, text) {
      this.gradecurrent = index;
      this.condition.grade = text;
      /* console.log(this.condition.grade);*/
      this.classifycurrent_ban = this.classNum;
      this.gradeNum = index;
      // console.log(this.condition.grade);
      this.sx();
      if (this.$route.path != this.link) {
        this.$router.push({
          path: this.link
        });
      }
    },
    subjectclickact: function(index, text) {
      this.subjectcurrent = index;
      this.condition.subject = text;
      this.sx();
      if (this.$route.path != this.link) {
        this.$router.push({
          path: this.link
        });
      }
    },
    formclickact: function(index, text) {
      this.formcurrent = index;
      this.link = text;

      this.sx();
      if (this.$route.path != this.link) {
        this.$router.push({
          path: this.link
        });
      }
    },
    datesclickact: function(index, text) {
      this.datescurrent = index;
      this.condition.dates = text;
      /*console.log(  this.condition.dates);*/
      this.sx();
      if (this.$route.path != this.link) {
        this.$router.push({
          path: this.link
        });
      }
    },
    //默认格式
    linkindex() {
      localStorage.setItem(
        "condition",
        JSON.stringify({
          classifycurrent: 0,
          gradecurrent: 0,
          subjectcurrent: 0,
          datescurrent: 0,
          formcurrent: 0,
          data: {
            classify: "高中",
            grade: "全部",
            subject: "全部",
            dates: "全部"
          },
          link: "/introducelist"
        })
      );
      this.$router.push({
        path: "/"
      });
    },
    linkytowin() {
      window.location.href = "http://www.ytowin.com/";
    }
  }
};
</script>

<style lang="less" scoped>
.breadnav {
  margin: 20px auto;
  li {
    display: inline-block;
    color: #5bab52;
    cursor: pointer;
    img {
      width: 78px;
      height: 33px;
      vertical-align: middle;
    }
    &:first-child {
      color: #000000;
    }
  }
}
.screen {
  padding: 23px;
  box-sizing: border-box;
  width: 1200px;
  height: 316px;
  background-color: #ffffff;
  box-shadow: 0px 1px 6px 0px rgba(18, 179, 117, 0.26);
  border-radius: 10px;
  margin-bottom: 80px;
  > h2 {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 116px;
    height: 34px;
    background-color: #5bab52;
    border-radius: 17px;
    font-size: 16px;
    font-weight: normal;
    line-height: 54px;
    color: #ffffff;
    margin-bottom: 34px;
  }

  .classify,
  .grade,
  .subject,
  .form,
  .dates {
    display: flex;
    > span {
      height: 30px;
      line-height: 30px;
      margin-right: 20px;
      font-size: 16px;
      font-weight: normal;
      color: #999999;
    }
    > ul {
      display: flex;
      margin-bottom: 25px;
      li {
        padding: 0 10px;
        height: 30px;
        cursor: pointer;
        margin: 0 10px;
        text-align: center;
        line-height: 30px;
      }
    }
  }
  .active {
    background-color: #5bab52;
    color: #ffffff;
    border-radius: 15px;
  }

  .active_ban {
    color: #fff;
    background-color: #ccc;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shaixuan.vue